export const HOME = 'home';
export const SUMMARY = 'summary';
export const ERROR = '*';
